import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { userAtom } from '@root/entities/auth'
import { useTranslation } from '@root/shared/localization'
import { InfoMessage, ProfileIcon } from '@root/shared/ui-kit'

import type { DelugeId } from '@root/entities/user-short'

type Props = {
  userId: DelugeId
}

export const UserConnectionsBoardFollowersEmpty = ({ userId }: Props) => {
  const { t } = useTranslation()
  const [profile] = useAtom(userAtom) // in case userProfileAtom fails

  const myProfile = profile?.delugeId === userId

  return (
    <Root>
      <InfoMessage
        intent="empty"
        variant="bold"
        withBackground
        title={
          myProfile
            ? t('profile.connections.followers.empty-title')
            : t('profile.connections.followers-other.empty-title')
        }
        description={
          myProfile
            ? t('profile.connections.followers.empty-description')
            : t('profile.connections.followers-other.empty-description')
        }
        icon={<ProfileIcon />}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  padding: 6px;
  display: grid;
  grid-template-rows: 1fr auto;
  border-radius: 12px;
  overflow: hidden;
`
